<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="父编码">
                  <el-select v-model="queryForm.dictParentCode" filterable clearable style="width:100%">
                    <el-option v-for="item in parentCodeList" :label="item" :value="item" :key="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="字典编码">
                  <el-select v-model="queryForm.dictCode" filterable clearable style="width:100%">
                    <el-option v-for="item in dictCodeList" :label="item.label" :value="item.value" :key="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button type="primary" @click="onClickAdd">添加</el-button>

    <el-table :data="tableData" v-loading="loading">
      <el-table-column prop="dictCode" label="字典编码"></el-table-column>
      <el-table-column prop="dictName" label="字典名称"></el-table-column>
      <el-table-column prop="dictParentCode" label="字典父编码"></el-table-column>
      <el-table-column prop="dictSort" label="排序"></el-table-column>
      <el-table-column prop="dataDictionaryValue" label="内容"></el-table-column>
      <el-table-column prop="dictNameEn" label="英文名称"></el-table-column>
      <el-table-column prop="pushAt" label="创建时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="pushAt" label="更新时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updateAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">编辑</el-link>
          <el-link type="primary" class="ml10" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog append-to-body :title="form.systemDataDictionaryId ? '编辑' : '添加'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item prop="dictParentCode" label="父编码" :rules="[{ required: true, message: '请输入父编码' }]">
          <el-autocomplete v-model="form.dictParentCode" :fetch-suggestions="querySearch"></el-autocomplete>
        </el-form-item>
        <el-form-item prop="dictCode" label="字典编码" :rules="[{ required: true, message: '请输入字典编码' }]">
          <el-input v-model="form.dictCode"></el-input>
        </el-form-item>
        <el-form-item prop="dictName" label="字典名称" :rules="[{ required: true, message: '请输入字典名称' }]">
          <el-input v-model="form.dictName"></el-input>
        </el-form-item>
        <el-form-item prop="dataDictionaryValue" label="内容" :rules="[{ required: true, message: '请输入内容' }]">
          <el-input type="textarea" :rows="4" v-model="form.dataDictionaryValue"></el-input>
        </el-form-item>
        <el-form-item prop="dictNameEn" label="英文名称">
          <el-input v-model="form.dictNameEn"></el-input>
        </el-form-item>
        <el-form-item prop="dictSort" label="排序">
          <el-input v-model="form.dictSort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  getDictList,
  addOrUpdateDict,
  delDict,
} from "../../../api/trace_cn";
import utils from '@/utils/util';

export default {
  data() {
    return {
      loading: false,
      daterange: [],
      queryForm: {
        dictParentCode: null,
        dictCode: null,
        pageNo: 1,
        pageSize: 25,
      },
      parentCodeList: [],
      dictCodeList: [],
      tableData: [],
      dialogVisible: false,
      form: {
        systemDataDictionaryId: null,
        dictCode: null,
        dictName: null,
        dictParentCode: null,
        dictSort: null,
        dataDictionaryValue: null,
        dictNameEn: null,
      },
    };
  },
  mounted() {
    this.getTableData(true);
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.dictParentCode = null;
      this.queryForm.dictCode = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData(init) {
      this.loading = true;
      getDictList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.tableData = res.data.data;
          if (init) {
            const parentCodeSet = new Set();
            const dictCodeList = [];
            this.tableData.forEach(item => {
              parentCodeSet.add(item.dictParentCode);
              dictCodeList.push({
                label: `${item.dictCode} - ${item.dictName}`,
                value: item.dictCode,
                key: `${item.dictCode}-${item.dictParentCode}`
              });
            });
            this.dictCodeList = dictCodeList;
            this.parentCodeList = [...parentCodeSet];
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    onClickAdd() {
      this.form.systemDataDictionaryId = null;
      this.form.dictCode = null;
      this.form.dictName = null;
      this.form.dictParentCode = null;
      this.form.dictSort = null;
      this.form.dataDictionaryValue = null;
      this.form.dictNameEn = null;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form.systemDataDictionaryId = row.systemDataDictionaryId;
      this.form.dictCode = row.dictCode;
      this.form.dictName = row.dictName;
      this.form.dictParentCode = row.dictParentCode;
      this.form.dictSort = row.dictSort;
      this.form.dataDictionaryValue = row.dataDictionaryValue;
      this.form.dictNameEn = row.dictNameEn;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    submit() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.$refs.form.validate((vali) => {
        if (vali) {
          addOrUpdateDict(this.form).then(res => {
            if (res.data && res.data.success) {
              this.$message.success('保存成功');
              this.getTableData();
              this.dialogVisible = false;
            }
            this.repeatSubmit = false;
          }).catch(() => {
            this.repeatSubmit = false;
          })
        } else {
          this.repeatSubmit = false;
        }
      })
    },
    removeItem(row) {
      this.$confirm(`确认删除${row.dictCode}-${row.dictName}吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDict({
          systemDataDictionaryId: row.systemDataDictionaryId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    querySearch(queryString, cb) {
      let restaurants = this.parentCodeList.map(item => ({ value: item }));
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
